<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">

        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <img src="./assets/images/norm35/Mesa de trabajo 8.png" alt="Logo-Norm35" class="centradoIMG ">
            <!-- CONTENT TOOLBAR -->

            <!-- / CONTENT TOOLBAR -->
            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 8%; margin-right: 8%;">
                <div *ngFor="let datita of dataStep8_inf">
                    <p *ngIf=" dataId.id == datita.position ">{{datita.tittle}}</p>
                </div>

                <div *ngFor="let datita of dataStep8_inf">
                    <span *ngIf=" dataId.id == datita.position "> {{datita.infoA}}</span>
                </div><br>

                <div *ngFor="let datita of dataStep8_inf">
                    <span *ngIf=" dataId.id == datita.position ">{{datita.infoB}}</span>
                </div><br>
                <div *ngFor="let datita of dataStep8_inf">
                    <span *ngIf=" dataId.id == datita.position ">{{datita.infoC}}</span>
                </div><br>
                <div *ngFor="let datita of dataStep8_inf">
                    <span *ngIf=" dataId.id == datita.position ">{{datita.infoD}}</span>
                </div><br>
                <div *ngFor="let datita of dataStep8_inf">
                    <span *ngIf=" dataId.id == datita.position ">{{datita.infoE}}</span>
                </div><br>
                <div *ngFor="let datita of dataStep8_inf">
                    <span *ngIf=" dataId.id == datita.position ">{{datita.infoF}}</span>
                </div><br>
                <div *ngFor="let datita of dataStep8_inf">
                    <span *ngIf=" dataId.id == datita.position ">{{datita.infoG}}</span>
                </div>

            </div>







            <!-- CONTENT -->

        </div>
        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

</div>
<!-- / CENTER -->
